import { Injectable } from '@angular/core';
import { ActionBackOfficeResponse } from '../../models/api.model';
import {
  EvConnectorTypeRow,
  EvConnectorTypeRowDto,
  EvConnectorTypeTableDto,
  InsertEvConnectorTypePayload,
  UpdateEvConnectorTypePayload,
} from '../../models/system-settings/ev-connector-type.model';

@Injectable({ providedIn: 'root' })
export class MapperEvConnectorTypeService {
  mapTableFromDto(dto: EvConnectorTypeTableDto): {
    items: EvConnectorTypeRow[];
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
  } {
    const raw = dto as EvConnectorTypeTableDto & Record<string, unknown>;
    const data = (dto.data ?? raw['Data'] ?? []) as EvConnectorTypeRowDto[];
    return {
      items: data.map((row) => this.mapRow(row)),
      total: dto.total ?? (raw['Total'] as number) ?? 0,
      page: dto.page ?? (raw['Page'] as number) ?? 1,
      pageSize: dto.pageSize ?? (raw['PageSize'] as number) ?? 20,
      totalPages: dto.totalPages ?? (raw['TotalPages'] as number) ?? 0,
    };
  }

  mapRow(dto: EvConnectorTypeRowDto): EvConnectorTypeRow {
    const raw = dto as EvConnectorTypeRowDto & Record<string, unknown>;
    return {
      id: dto.id ?? (raw['Id'] as number) ?? 0,
      code: String(dto.code ?? raw['Code'] ?? '').toLowerCase(),
      name: String(dto.name ?? raw['Name'] ?? ''),
      nameEn: String(dto.nameEn ?? raw['NameEn'] ?? ''),
      description: String(dto.description ?? raw['Description'] ?? ''),
      sortOrder: this.asNumber(dto.sortOrder ?? raw['SortOrder']),
      active: !!(dto.active ?? raw['Active'] ?? false),
      createDate: this.asString(dto.createDate ?? raw['CreateDate']),
      writeDate: this.asString(dto.writeDate ?? raw['WriteDate']),
    };
  }

  createEmpty(): EvConnectorTypeRow {
    return {
      id: 0,
      code: 'ac',
      name: '',
      nameEn: '',
      description: '',
      sortOrder: 0,
      active: true,
      createDate: null,
      writeDate: null,
    };
  }

  mapInsertPayload(form: EvConnectorTypeRow, userId: number, menuId: number): InsertEvConnectorTypePayload {
    return {
      userId,
      menuId,
      code: form.code.trim().toLowerCase(),
      name: form.name.trim(),
      nameEn: form.nameEn?.trim() || null,
      description: form.description?.trim() || null,
      sortOrder: form.sortOrder,
      active: !!form.active,
    };
  }

  mapUpdatePayload(form: EvConnectorTypeRow, userId: number, menuId: number): UpdateEvConnectorTypePayload {
    return {
      ...this.mapInsertPayload(form, userId, menuId),
      id: form.id,
    };
  }

  mapActionResponse(res: ActionBackOfficeResponse | Record<string, unknown>) {
    const raw = res as Record<string, unknown>;
    return {
      isSuccess: !!((res as ActionBackOfficeResponse).isSuccess ?? raw['IsSuccess']),
      message: String((res as ActionBackOfficeResponse).message ?? raw['Message'] ?? ''),
    };
  }

  private asString(value: unknown): string | null {
    if (value == null || value === '') return null;
    return String(value);
  }

  private asNumber(value: unknown): number | null {
    if (value == null || value === '') return null;
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }
}
